import { Link } from "react-router-dom";
import { Compass, Mail, Phone, Twitter, Linkedin, Facebook } from "lucide-react";

export function Footer({ settings }) {
  return (
    <footer className="mt-24 bg-primary text-slate-200 dark:bg-slate-950">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <img src="/noventra-logo.png" alt="Noventra Academic Press" className="w-9 h-9 rounded-lg object-cover bg-white" />
            <span className="font-serif font-bold text-white text-lg">Noventra Academic Press</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            {settings?.tagline || "Open Access Peer-Reviewed International Journals"}
          </p>
          <div className="flex gap-3 mt-5">
            {[
              { url: settings?.social_twitter, Icon: Twitter },
              { url: settings?.social_linkedin, Icon: Linkedin },
              { url: settings?.social_facebook, Icon: Facebook },
            ].filter((s) => s.url).map(({ url, Icon }, i) => (
              <a key={i} href={url} target="_blank" rel="noopener noreferrer" className="grid place-items-center w-9 h-9 rounded-full bg-white/5 hover:bg-amber-500 transition-colors">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-sans font-semibold mb-4 text-sm uppercase tracking-wider">Explore</h4>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link to="/journals" className="hover:text-amber-400 transition-colors">All Journals</Link></li>
            <li><Link to="/#categories" className="hover:text-amber-400 transition-colors">Subject Areas</Link></li>
            <li><Link to="/#special-issues" className="hover:text-amber-400 transition-colors">Special Issues</Link></li>
            <li><Link to="/submit" className="hover:text-amber-400 transition-colors">Submit a Paper</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-sans font-semibold mb-4 text-sm uppercase tracking-wider">For Authors</h4>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link to="/submit" className="hover:text-amber-400 transition-colors">Paper Submission</Link></li>
            <li><Link to="/peer-review" className="hover:text-amber-400 transition-colors">Peer Review Process</Link></li>
            <li><Link to="/open-access" className="hover:text-amber-400 transition-colors">Open Access Policy</Link></li>
            <li><Link to="/publication-ethics" className="hover:text-amber-400 transition-colors">Publication Ethics</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-sans font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h4>
          <a href={`mailto:${settings?.contact_email || "editorial@noventrapress.org"}`} className="flex items-center gap-2 text-sm text-slate-400 hover:text-amber-400 transition-colors">
            <Mail className="w-4 h-4" /> {settings?.contact_email || "editorial@noventrapress.org"}
          </a>
          {settings?.contact_phone && (
            <a href={`tel:${settings.contact_phone.replace(/[^+\d]/g, "")}`} className="flex items-center gap-2 text-sm text-slate-400 hover:text-amber-400 transition-colors mt-2.5">
              <Phone className="w-4 h-4" /> {settings.contact_phone}
            </a>
          )}
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 text-xs text-slate-500">
          {settings?.footer_text || "© 2026 Noventra Academic Press. All rights reserved."}
        </div>
      </div>
    </footer>
  );
}
